import {
  getLocalStorage,
  setLocalStorage,
} from 'shared/libs/storage/localStorage'

const THEME_KEY = 'app-theme'

export const useTheme = () => {
  const currentTheme = getLocalStorage(THEME_KEY) || 'light'

  const toggleTheme = () => {
    const newTheme = currentTheme === 'light' ? 'dark' : 'light'

    setLocalStorage({
      key: THEME_KEY,
      value: newTheme,
    })
  }

  return { currentTheme, toggleTheme }
}
